import { Component, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ConstantsService, SessionService, CompaniesEnum, LookupsService, LimitlessUiService, LoggerService } from '@app/base/core';

@Component({
  selector: 'app-shell',
  templateUrl: './app-shell.component.html',
})

export class AppShellComponent implements OnInit {

  public measurementID:string="";
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private logger: LoggerService,
    private lookupSvc: LookupsService,
    private limitlessSvc: LimitlessUiService,
    private constantsSvc: ConstantsService,
    private sessionSvc: SessionService
  ) {

    // // Mark App Shell Bootstrapped -> Browser Console
    this.logger.log(`%c » App Shell Bootstrapped`, 'background: #3c3c3c; color: white; font-size: 13px;');
  }

  ngOnInit() {
    
    // Load common lookups
    if (!this.lookupSvc.commonLookupsLoaded) {
      this.lookupSvc.loadCommonLookups();
    }

    // Subscribe and handle route\router events
    this.subscribeRouteEvents();
  }

    private subscribeRouteEvents() {
    // Detect and resolve parameterized LDC
    this.route.params.subscribe(params => {

      const defaultLdc = this.constantsSvc.defaultLdc;
      if (params['ldc']) { // If we received ldc, then try to match it with a known LDC enum
        const paramLdc = String(params['ldc']).trim().toUpperCase();
        // Ensure that incoming query param is matching one of known LDCs in Companies enum before stroing it.
        if ((Object.keys(CompaniesEnum).map(e => CompaniesEnum[e].toUpperCase()).indexOf(paramLdc) >= 0)) {
          if (paramLdc === defaultLdc.toUpperCase()) {
            this.navigateToLanding();
          } else {
            this.sessionSvc.paramLdc = params['ldc'].trim().toUpperCase();
          }
        } else { this.navigateToLanding(); } // Value passed in :ldc is unknown LDC, Route to company and pass default LDC as :ldc
      } else { this.navigateToLanding(); } // No LDC passed in route, route to company and pass default LDC as :ldc
    });

    // Listen for route changes and update paramLDC\activeLDC accordingly.
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
      // User navigating to company\landing page && paramLdc is not default 'SC', user coming from app
      // pages to company\landing, then show default company 'SC'.
      if (event.url.indexOf('company') > -1 && this.sessionSvc.paramLdc !== this.constantsSvc.defaultLdc) {
        this.sessionSvc.paramLdc = this.constantsSvc.defaultLdc;
      }

      // Update activeLdc based on paramLdc
      if (this.lookupSvc.companies) {
        this.sessionSvc.activeLdc = this.lookupSvc.companies[this.sessionSvc.paramLdc];
      }

      // This gets executed when user navigate from on component to the other;
      this.limitlessSvc.initLimitless();
    });
  }

  private navigateToLanding() {
    this.router.navigate([this.constantsSvc.defaultLdc.toLowerCase(), 'company']);
  }




}
